import { Component } from '@angular/core';

@Component({
  selector: 'app-telecura-impressum',
  imports: [],
  templateUrl: './telecura-impressum.component.html',
  styleUrl: '../impressum.component.sass'
})
export class TelecuraImpressumComponent {

  constructor() {
  }
}
